import * as re from "react";
import Br, { forwardRef as qr, useContext as Pt, useState as Nt } from "react";
import { css as F } from "@emotion/react";
import { CloseIcon as At } from "@illa-design/icon";
import { omit as kt } from "@illa-design/system";
import { globalColor as U, illaPrefix as B, applyBoxStyle as It, deleteCssProps as Dt } from "@illa-design/theme";
var ir = { exports: {} }, be = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nr;
function Ft() {
  if (Nr)
    return be;
  Nr = 1;
  var e = Br, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(f, p, v) {
    var d, y = {}, S = null, N = null;
    v !== void 0 && (S = "" + v), p.key !== void 0 && (S = "" + p.key), p.ref !== void 0 && (N = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (y[d] = p[d]);
    if (f && f.defaultProps)
      for (d in p = f.defaultProps, p)
        y[d] === void 0 && (y[d] = p[d]);
    return { $$typeof: r, type: f, key: S, ref: N, props: y, _owner: o.current };
  }
  return be.Fragment = n, be.jsx = l, be.jsxs = l, be;
}
var Ee = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ar;
function Mt() {
  return Ar || (Ar = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Br, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), f = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), N = Symbol.for("react.offscreen"), $ = Symbol.iterator, E = "@@iterator";
    function M(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = $ && t[$] || t[E];
      return typeof s == "function" ? s : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
          u[m - 1] = arguments[m];
        A("error", t, u);
      }
    }
    function A(t, s, u) {
      {
        var m = x.ReactDebugCurrentFrame, w = m.getStackAddendum();
        w !== "" && (s += "%s", u = u.concat([w]));
        var k = u.map(function(_) {
          return String(_);
        });
        k.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, k);
      }
    }
    var I = !1, c = !1, L = !1, P = !1, Je = !1, Ce;
    Ce = Symbol.for("react.module.reference");
    function Ke(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || Je || t === o || t === v || t === d || P || t === N || I || c || L || typeof t == "object" && t !== null && (t.$$typeof === S || t.$$typeof === y || t.$$typeof === l || t.$$typeof === f || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Ce || t.getModuleId !== void 0));
    }
    function He(t, s, u) {
      var m = t.displayName;
      if (m)
        return m;
      var w = s.displayName || s.name || "";
      return w !== "" ? u + "(" + w + ")" : u;
    }
    function Te(t) {
      return t.displayName || "Context";
    }
    function K(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case v:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case f:
            var s = t;
            return Te(s) + ".Consumer";
          case l:
            var u = t;
            return Te(u._context) + ".Provider";
          case p:
            return He(t, t.render, "ForwardRef");
          case y:
            var m = t.displayName || null;
            return m !== null ? m : K(t.type) || "Memo";
          case S: {
            var w = t, k = w._payload, _ = w._init;
            try {
              return K(_(k));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Q = Object.assign, te = 0, Oe, $e, de, Pe, pe, Ne, Ae;
    function ke() {
    }
    ke.__reactDisabledLog = !0;
    function Ze() {
      {
        if (te === 0) {
          Oe = console.log, $e = console.info, de = console.warn, Pe = console.error, pe = console.group, Ne = console.groupCollapsed, Ae = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: ke,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        te++;
      }
    }
    function Xe() {
      {
        if (te--, te === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Q({}, t, {
              value: Oe
            }),
            info: Q({}, t, {
              value: $e
            }),
            warn: Q({}, t, {
              value: de
            }),
            error: Q({}, t, {
              value: Pe
            }),
            group: Q({}, t, {
              value: pe
            }),
            groupCollapsed: Q({}, t, {
              value: Ne
            }),
            groupEnd: Q({}, t, {
              value: Ae
            })
          });
        }
        te < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var he = x.ReactCurrentDispatcher, ve;
    function ae(t, s, u) {
      {
        if (ve === void 0)
          try {
            throw Error();
          } catch (w) {
            var m = w.stack.trim().match(/\n( *(at )?)/);
            ve = m && m[1] || "";
          }
        return `
` + ve + t;
      }
    }
    var me = !1, oe;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      oe = new Qe();
    }
    function h(t, s) {
      if (!t || me)
        return "";
      {
        var u = oe.get(t);
        if (u !== void 0)
          return u;
      }
      var m;
      me = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var k;
      k = he.current, he.current = null, Ze();
      try {
        if (s) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (ee) {
              m = ee;
            }
            Reflect.construct(t, [], _);
          } else {
            try {
              _.call();
            } catch (ee) {
              m = ee;
            }
            t.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ee) {
            m = ee;
          }
          t();
        }
      } catch (ee) {
        if (ee && m && typeof ee.stack == "string") {
          for (var b = ee.stack.split(`
`), W = m.stack.split(`
`), D = b.length - 1, j = W.length - 1; D >= 1 && j >= 0 && b[D] !== W[j]; )
            j--;
          for (; D >= 1 && j >= 0; D--, j--)
            if (b[D] !== W[j]) {
              if (D !== 1 || j !== 1)
                do
                  if (D--, j--, j < 0 || b[D] !== W[j]) {
                    var J = `
` + b[D].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && oe.set(t, J), J;
                  }
                while (D >= 1 && j >= 0);
              break;
            }
        }
      } finally {
        me = !1, he.current = k, Xe(), Error.prepareStackTrace = w;
      }
      var ce = t ? t.displayName || t.name : "", Pr = ce ? ae(ce) : "";
      return typeof t == "function" && oe.set(t, Pr), Pr;
    }
    function ye(t, s, u) {
      return h(t, !1);
    }
    function ie(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function ne(t, s, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return h(t, ie(t));
      if (typeof t == "string")
        return ae(t);
      switch (t) {
        case v:
          return ae("Suspense");
        case d:
          return ae("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return ye(t.render);
          case y:
            return ne(t.type, s, u);
          case S: {
            var m = t, w = m._payload, k = m._init;
            try {
              return ne(k(w), s, u);
            } catch {
            }
          }
        }
      return "";
    }
    var Ie = Object.prototype.hasOwnProperty, gr = {}, br = x.ReactDebugCurrentFrame;
    function De(t) {
      if (t) {
        var s = t._owner, u = ne(t.type, t._source, s ? s.type : null);
        br.setExtraStackFrame(u);
      } else
        br.setExtraStackFrame(null);
    }
    function ft(t, s, u, m, w) {
      {
        var k = Function.call.bind(Ie);
        for (var _ in t)
          if (k(t, _)) {
            var b = void 0;
            try {
              if (typeof t[_] != "function") {
                var W = Error((m || "React class") + ": " + u + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              b = t[_](s, _, m, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (D) {
              b = D;
            }
            b && !(b instanceof Error) && (De(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", u, _, typeof b), De(null)), b instanceof Error && !(b.message in gr) && (gr[b.message] = !0, De(w), g("Failed %s type: %s", u, b.message), De(null));
          }
      }
    }
    var lt = Array.isArray;
    function er(t) {
      return lt(t);
    }
    function dt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, u = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function pt(t) {
      try {
        return Er(t), !1;
      } catch {
        return !0;
      }
    }
    function Er(t) {
      return "" + t;
    }
    function _r(t) {
      if (pt(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", dt(t)), Er(t);
    }
    var ge = x.ReactCurrentOwner, ht = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xr, Sr, rr;
    rr = {};
    function vt(t) {
      if (Ie.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mt(t) {
      if (Ie.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function yt(t, s) {
      if (typeof t.ref == "string" && ge.current && s && ge.current.stateNode !== s) {
        var u = K(ge.current.type);
        rr[u] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', K(ge.current.type), t.ref), rr[u] = !0);
      }
    }
    function gt(t, s) {
      {
        var u = function() {
          xr || (xr = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function bt(t, s) {
      {
        var u = function() {
          Sr || (Sr = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var Et = function(t, s, u, m, w, k, _) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: u,
        props: _,
        // Record the component responsible for creating this element.
        _owner: k
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function _t(t, s, u, m, w) {
      {
        var k, _ = {}, b = null, W = null;
        u !== void 0 && (_r(u), b = "" + u), mt(s) && (_r(s.key), b = "" + s.key), vt(s) && (W = s.ref, yt(s, w));
        for (k in s)
          Ie.call(s, k) && !ht.hasOwnProperty(k) && (_[k] = s[k]);
        if (t && t.defaultProps) {
          var D = t.defaultProps;
          for (k in D)
            _[k] === void 0 && (_[k] = D[k]);
        }
        if (b || W) {
          var j = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          b && gt(_, j), W && bt(_, j);
        }
        return Et(t, b, W, w, m, ge.current, _);
      }
    }
    var tr = x.ReactCurrentOwner, wr = x.ReactDebugCurrentFrame;
    function se(t) {
      if (t) {
        var s = t._owner, u = ne(t.type, t._source, s ? s.type : null);
        wr.setExtraStackFrame(u);
      } else
        wr.setExtraStackFrame(null);
    }
    var nr;
    nr = !1;
    function ar(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Rr() {
      {
        if (tr.current) {
          var t = K(tr.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function xt(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), u = t.lineNumber;
          return `

Check your code at ` + s + ":" + u + ".";
        }
        return "";
      }
    }
    var Cr = {};
    function St(t) {
      {
        var s = Rr();
        if (!s) {
          var u = typeof t == "string" ? t : t.displayName || t.name;
          u && (s = `

Check the top-level render call using <` + u + ">.");
        }
        return s;
      }
    }
    function Tr(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var u = St(s);
        if (Cr[u])
          return;
        Cr[u] = !0;
        var m = "";
        t && t._owner && t._owner !== tr.current && (m = " It was passed a child from " + K(t._owner.type) + "."), se(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, m), se(null);
      }
    }
    function Or(t, s) {
      {
        if (typeof t != "object")
          return;
        if (er(t))
          for (var u = 0; u < t.length; u++) {
            var m = t[u];
            ar(m) && Tr(m, s);
          }
        else if (ar(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = M(t);
          if (typeof w == "function" && w !== t.entries)
            for (var k = w.call(t), _; !(_ = k.next()).done; )
              ar(_.value) && Tr(_.value, s);
        }
      }
    }
    function wt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var u;
        if (typeof s == "function")
          u = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          u = s.propTypes;
        else
          return;
        if (u) {
          var m = K(s);
          ft(u, t.props, "prop", m, t);
        } else if (s.PropTypes !== void 0 && !nr) {
          nr = !0;
          var w = K(s);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Rt(t) {
      {
        for (var s = Object.keys(t.props), u = 0; u < s.length; u++) {
          var m = s[u];
          if (m !== "children" && m !== "key") {
            se(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), se(null);
            break;
          }
        }
        t.ref !== null && (se(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), se(null));
      }
    }
    function $r(t, s, u, m, w, k) {
      {
        var _ = Ke(t);
        if (!_) {
          var b = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = xt(w);
          W ? b += W : b += Rr();
          var D;
          t === null ? D = "null" : er(t) ? D = "array" : t !== void 0 && t.$$typeof === r ? (D = "<" + (K(t.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : D = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", D, b);
        }
        var j = _t(t, s, u, w, k);
        if (j == null)
          return j;
        if (_) {
          var J = s.children;
          if (J !== void 0)
            if (m)
              if (er(J)) {
                for (var ce = 0; ce < J.length; ce++)
                  Or(J[ce], t);
                Object.freeze && Object.freeze(J);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Or(J, t);
        }
        return t === a ? Rt(j) : wt(j), j;
      }
    }
    function Ct(t, s, u) {
      return $r(t, s, u, !0);
    }
    function Tt(t, s, u) {
      return $r(t, s, u, !1);
    }
    var Ot = Tt, $t = Ct;
    Ee.Fragment = a, Ee.jsx = Ot, Ee.jsxs = $t;
  }()), Ee;
}
process.env.NODE_ENV === "production" ? ir.exports = Ft() : ir.exports = Mt();
var Ye = ir.exports;
function jt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Vt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Lt = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Vt(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var l = jt(o);
      try {
        l.insertRule(a, l.cssRules.length);
      } catch (f) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', f);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), z = "-ms-", ze = "-moz-", R = "-webkit-", dr = "comm", pr = "rule", hr = "decl", Yt = "@import", Gr = "@keyframes", zt = "@layer", Wt = Math.abs, Ue = String.fromCharCode, Ut = Object.assign;
function Bt(e, r) {
  return Y(e, 0) ^ 45 ? (((r << 2 ^ Y(e, 0)) << 2 ^ Y(e, 1)) << 2 ^ Y(e, 2)) << 2 ^ Y(e, 3) : 0;
}
function Jr(e) {
  return e.trim();
}
function qt(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function C(e, r, n) {
  return e.replace(r, n);
}
function sr(e, r) {
  return e.indexOf(r);
}
function Y(e, r) {
  return e.charCodeAt(r) | 0;
}
function xe(e, r, n) {
  return e.slice(r, n);
}
function Z(e) {
  return e.length;
}
function vr(e) {
  return e.length;
}
function Fe(e, r) {
  return r.push(e), e;
}
function Gt(e, r) {
  return e.map(r).join("");
}
var Be = 1, fe = 1, Kr = 0, q = 0, V = 0, le = "";
function qe(e, r, n, a, o, i, l) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: Be, column: fe, length: l, return: "" };
}
function _e(e, r) {
  return Ut(qe("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Jt() {
  return V;
}
function Kt() {
  return V = q > 0 ? Y(le, --q) : 0, fe--, V === 10 && (fe = 1, Be--), V;
}
function G() {
  return V = q < Kr ? Y(le, q++) : 0, fe++, V === 10 && (fe = 1, Be++), V;
}
function X() {
  return Y(le, q);
}
function je() {
  return q;
}
function Re(e, r) {
  return xe(le, e, r);
}
function Se(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Hr(e) {
  return Be = fe = 1, Kr = Z(le = e), q = 0, [];
}
function Zr(e) {
  return le = "", e;
}
function Ve(e) {
  return Jr(Re(q - 1, cr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Ht(e) {
  for (; (V = X()) && V < 33; )
    G();
  return Se(e) > 2 || Se(V) > 3 ? "" : " ";
}
function Zt(e, r) {
  for (; --r && G() && !(V < 48 || V > 102 || V > 57 && V < 65 || V > 70 && V < 97); )
    ;
  return Re(e, je() + (r < 6 && X() == 32 && G() == 32));
}
function cr(e) {
  for (; G(); )
    switch (V) {
      case e:
        return q;
      case 34:
      case 39:
        e !== 34 && e !== 39 && cr(V);
        break;
      case 40:
        e === 41 && cr(e);
        break;
      case 92:
        G();
        break;
    }
  return q;
}
function Xt(e, r) {
  for (; G() && e + V !== 47 + 10; )
    if (e + V === 42 + 42 && X() === 47)
      break;
  return "/*" + Re(r, q - 1) + "*" + Ue(e === 47 ? e : G());
}
function Qt(e) {
  for (; !Se(X()); )
    G();
  return Re(e, q);
}
function en(e) {
  return Zr(Le("", null, null, null, [""], e = Hr(e), 0, [0], e));
}
function Le(e, r, n, a, o, i, l, f, p) {
  for (var v = 0, d = 0, y = l, S = 0, N = 0, $ = 0, E = 1, M = 1, x = 1, g = 0, A = "", I = o, c = i, L = a, P = A; M; )
    switch ($ = g, g = G()) {
      case 40:
        if ($ != 108 && Y(P, y - 1) == 58) {
          sr(P += C(Ve(g), "&", "&\f"), "&\f") != -1 && (x = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        P += Ve(g);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        P += Ht($);
        break;
      case 92:
        P += Zt(je() - 1, 7);
        continue;
      case 47:
        switch (X()) {
          case 42:
          case 47:
            Fe(rn(Xt(G(), je()), r, n), p);
            break;
          default:
            P += "/";
        }
        break;
      case 123 * E:
        f[v++] = Z(P) * x;
      case 125 * E:
      case 59:
      case 0:
        switch (g) {
          case 0:
          case 125:
            M = 0;
          case 59 + d:
            x == -1 && (P = C(P, /\f/g, "")), N > 0 && Z(P) - y && Fe(N > 32 ? Ir(P + ";", a, n, y - 1) : Ir(C(P, " ", "") + ";", a, n, y - 2), p);
            break;
          case 59:
            P += ";";
          default:
            if (Fe(L = kr(P, r, n, v, d, o, f, A, I = [], c = [], y), i), g === 123)
              if (d === 0)
                Le(P, r, L, L, I, i, y, f, c);
              else
                switch (S === 99 && Y(P, 3) === 110 ? 100 : S) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Le(e, L, L, a && Fe(kr(e, L, L, 0, 0, o, f, A, o, I = [], y), c), o, c, y, f, a ? I : c);
                    break;
                  default:
                    Le(P, L, L, L, [""], c, 0, f, c);
                }
        }
        v = d = N = 0, E = x = 1, A = P = "", y = l;
        break;
      case 58:
        y = 1 + Z(P), N = $;
      default:
        if (E < 1) {
          if (g == 123)
            --E;
          else if (g == 125 && E++ == 0 && Kt() == 125)
            continue;
        }
        switch (P += Ue(g), g * E) {
          case 38:
            x = d > 0 ? 1 : (P += "\f", -1);
            break;
          case 44:
            f[v++] = (Z(P) - 1) * x, x = 1;
            break;
          case 64:
            X() === 45 && (P += Ve(G())), S = X(), d = y = Z(A = P += Qt(je())), g++;
            break;
          case 45:
            $ === 45 && Z(P) == 2 && (E = 0);
        }
    }
  return i;
}
function kr(e, r, n, a, o, i, l, f, p, v, d) {
  for (var y = o - 1, S = o === 0 ? i : [""], N = vr(S), $ = 0, E = 0, M = 0; $ < a; ++$)
    for (var x = 0, g = xe(e, y + 1, y = Wt(E = l[$])), A = e; x < N; ++x)
      (A = Jr(E > 0 ? S[x] + " " + g : C(g, /&\f/g, S[x]))) && (p[M++] = A);
  return qe(e, r, n, o === 0 ? pr : f, p, v, d);
}
function rn(e, r, n) {
  return qe(e, r, n, dr, Ue(Jt()), xe(e, 2, -2), 0);
}
function Ir(e, r, n, a) {
  return qe(e, r, n, hr, xe(e, 0, a), xe(e, a + 1, -1), a);
}
function ue(e, r) {
  for (var n = "", a = vr(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function tn(e, r, n, a) {
  switch (e.type) {
    case zt:
      if (e.children.length)
        break;
    case Yt:
    case hr:
      return e.return = e.return || e.value;
    case dr:
      return "";
    case Gr:
      return e.return = e.value + "{" + ue(e.children, a) + "}";
    case pr:
      e.value = e.props.join(",");
  }
  return Z(n = ue(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function nn(e) {
  var r = vr(e);
  return function(n, a, o, i) {
    for (var l = "", f = 0; f < r; f++)
      l += e[f](n, a, o, i) || "";
    return l;
  };
}
function an(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function on(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var sn = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = X(), o === 38 && i === 12 && (n[a] = 1), !Se(i); )
    G();
  return Re(r, q);
}, cn = function(r, n) {
  var a = -1, o = 44;
  do
    switch (Se(o)) {
      case 0:
        o === 38 && X() === 12 && (n[a] = 1), r[a] += sn(q - 1, n, a);
        break;
      case 2:
        r[a] += Ve(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = X() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += Ue(o);
    }
  while (o = G());
  return r;
}, un = function(r, n) {
  return Zr(cn(Hr(r), n));
}, Dr = /* @__PURE__ */ new WeakMap(), fn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Dr.get(a)) && !o) {
      Dr.set(r, !0);
      for (var i = [], l = un(n, i), f = a.props, p = 0, v = 0; p < l.length; p++)
        for (var d = 0; d < f.length; d++, v++)
          r.props[v] = i[p] ? l[p].replace(/&\f/g, f[d]) : f[d] + " " + l[p];
    }
  }
}, ln = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, dn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", pn = function(r) {
  return r.type === "comm" && r.children.indexOf(dn) > -1;
}, hn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var l = !!n.parent, f = l ? n.parent.children : (
          // global rule at the root level
          o
        ), p = f.length - 1; p >= 0; p--) {
          var v = f[p];
          if (v.line < n.line)
            break;
          if (v.column < n.column) {
            if (pn(v))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, Xr = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, vn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!Xr(n[a]))
      return !0;
  return !1;
}, Fr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, mn = function(r, n, a) {
  Xr(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Fr(r)) : vn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Fr(r)));
};
function Qr(e, r) {
  switch (Bt(e, r)) {
    case 5103:
      return R + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return R + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return R + e + ze + e + z + e + e;
    case 6828:
    case 4268:
      return R + e + z + e + e;
    case 6165:
      return R + e + z + "flex-" + e + e;
    case 5187:
      return R + e + C(e, /(\w+).+(:[^]+)/, R + "box-$1$2" + z + "flex-$1$2") + e;
    case 5443:
      return R + e + z + "flex-item-" + C(e, /flex-|-self/, "") + e;
    case 4675:
      return R + e + z + "flex-line-pack" + C(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return R + e + z + C(e, "shrink", "negative") + e;
    case 5292:
      return R + e + z + C(e, "basis", "preferred-size") + e;
    case 6060:
      return R + "box-" + C(e, "-grow", "") + R + e + z + C(e, "grow", "positive") + e;
    case 4554:
      return R + C(e, /([^-])(transform)/g, "$1" + R + "$2") + e;
    case 6187:
      return C(C(C(e, /(zoom-|grab)/, R + "$1"), /(image-set)/, R + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return C(e, /(image-set\([^]*)/, R + "$1$`$1");
    case 4968:
      return C(C(e, /(.+:)(flex-)?(.*)/, R + "box-pack:$3" + z + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + R + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return C(e, /(.+)-inline(.+)/, R + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Z(e) - 1 - r > 6)
        switch (Y(e, r + 1)) {
          case 109:
            if (Y(e, r + 4) !== 45)
              break;
          case 102:
            return C(e, /(.+:)(.+)-([^]+)/, "$1" + R + "$2-$3$1" + ze + (Y(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~sr(e, "stretch") ? Qr(C(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (Y(e, r + 1) !== 115)
        break;
    case 6444:
      switch (Y(e, Z(e) - 3 - (~sr(e, "!important") && 10))) {
        case 107:
          return C(e, ":", ":" + R) + e;
        case 101:
          return C(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + R + (Y(e, 14) === 45 ? "inline-" : "") + "box$3$1" + R + "$2$3$1" + z + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Y(e, r + 11)) {
        case 114:
          return R + e + z + C(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return R + e + z + C(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return R + e + z + C(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return R + e + z + e + e;
  }
  return e;
}
var yn = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case hr:
        r.return = Qr(r.value, r.length);
        break;
      case Gr:
        return ue([_e(r, {
          value: C(r.value, "@", "@" + R)
        })], o);
      case pr:
        if (r.length)
          return Gt(r.props, function(i) {
            switch (qt(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ue([_e(r, {
                  props: [C(i, /:(read-\w+)/, ":" + ze + "$1")]
                })], o);
              case "::placeholder":
                return ue([_e(r, {
                  props: [C(i, /:(plac\w+)/, ":" + R + "input-$1")]
                }), _e(r, {
                  props: [C(i, /:(plac\w+)/, ":" + ze + "$1")]
                }), _e(r, {
                  props: [C(i, /:(plac\w+)/, z + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, gn = [yn], bn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(E) {
      var M = E.getAttribute("data-emotion");
      M.indexOf(" ") !== -1 && (document.head.appendChild(E), E.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || gn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, l, f = [];
  l = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(E) {
      for (var M = E.getAttribute("data-emotion").split(" "), x = 1; x < M.length; x++)
        i[M[x]] = !0;
      f.push(E);
    }
  );
  var p, v = [fn, ln];
  process.env.NODE_ENV !== "production" && v.push(hn({
    get compat() {
      return $.compat;
    }
  }), mn);
  {
    var d, y = [tn, process.env.NODE_ENV !== "production" ? function(E) {
      E.root || (E.return ? d.insert(E.return) : E.value && E.type !== dr && d.insert(E.value + "{}"));
    } : an(function(E) {
      d.insert(E);
    })], S = nn(v.concat(o, y)), N = function(M) {
      return ue(en(M), S);
    };
    p = function(M, x, g, A) {
      d = g, process.env.NODE_ENV !== "production" && x.map !== void 0 && (d = {
        insert: function(c) {
          g.insert(c + x.map);
        }
      }), N(M ? M + "{" + x.styles + "}" : x.styles), A && ($.inserted[x.name] = !0);
    };
  }
  var $ = {
    key: n,
    sheet: new Lt({
      key: n,
      container: l,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return $.sheet.hydrate(f), $;
}, ur = { exports: {} }, T = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mr;
function En() {
  if (Mr)
    return T;
  Mr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, S = e ? Symbol.for("react.suspense_list") : 60120, N = e ? Symbol.for("react.memo") : 60115, $ = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, M = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
  function A(c) {
    if (typeof c == "object" && c !== null) {
      var L = c.$$typeof;
      switch (L) {
        case r:
          switch (c = c.type, c) {
            case p:
            case v:
            case a:
            case i:
            case o:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case f:
                case d:
                case $:
                case N:
                case l:
                  return c;
                default:
                  return L;
              }
          }
        case n:
          return L;
      }
    }
  }
  function I(c) {
    return A(c) === v;
  }
  return T.AsyncMode = p, T.ConcurrentMode = v, T.ContextConsumer = f, T.ContextProvider = l, T.Element = r, T.ForwardRef = d, T.Fragment = a, T.Lazy = $, T.Memo = N, T.Portal = n, T.Profiler = i, T.StrictMode = o, T.Suspense = y, T.isAsyncMode = function(c) {
    return I(c) || A(c) === p;
  }, T.isConcurrentMode = I, T.isContextConsumer = function(c) {
    return A(c) === f;
  }, T.isContextProvider = function(c) {
    return A(c) === l;
  }, T.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, T.isForwardRef = function(c) {
    return A(c) === d;
  }, T.isFragment = function(c) {
    return A(c) === a;
  }, T.isLazy = function(c) {
    return A(c) === $;
  }, T.isMemo = function(c) {
    return A(c) === N;
  }, T.isPortal = function(c) {
    return A(c) === n;
  }, T.isProfiler = function(c) {
    return A(c) === i;
  }, T.isStrictMode = function(c) {
    return A(c) === o;
  }, T.isSuspense = function(c) {
    return A(c) === y;
  }, T.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === v || c === i || c === o || c === y || c === S || typeof c == "object" && c !== null && (c.$$typeof === $ || c.$$typeof === N || c.$$typeof === l || c.$$typeof === f || c.$$typeof === d || c.$$typeof === M || c.$$typeof === x || c.$$typeof === g || c.$$typeof === E);
  }, T.typeOf = A, T;
}
var O = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jr;
function _n() {
  return jr || (jr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, S = e ? Symbol.for("react.suspense_list") : 60120, N = e ? Symbol.for("react.memo") : 60115, $ = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, M = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
    function A(h) {
      return typeof h == "string" || typeof h == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      h === a || h === v || h === i || h === o || h === y || h === S || typeof h == "object" && h !== null && (h.$$typeof === $ || h.$$typeof === N || h.$$typeof === l || h.$$typeof === f || h.$$typeof === d || h.$$typeof === M || h.$$typeof === x || h.$$typeof === g || h.$$typeof === E);
    }
    function I(h) {
      if (typeof h == "object" && h !== null) {
        var ye = h.$$typeof;
        switch (ye) {
          case r:
            var ie = h.type;
            switch (ie) {
              case p:
              case v:
              case a:
              case i:
              case o:
              case y:
                return ie;
              default:
                var ne = ie && ie.$$typeof;
                switch (ne) {
                  case f:
                  case d:
                  case $:
                  case N:
                  case l:
                    return ne;
                  default:
                    return ye;
                }
            }
          case n:
            return ye;
        }
      }
    }
    var c = p, L = v, P = f, Je = l, Ce = r, Ke = d, He = a, Te = $, K = N, Q = n, te = i, Oe = o, $e = y, de = !1;
    function Pe(h) {
      return de || (de = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), pe(h) || I(h) === p;
    }
    function pe(h) {
      return I(h) === v;
    }
    function Ne(h) {
      return I(h) === f;
    }
    function Ae(h) {
      return I(h) === l;
    }
    function ke(h) {
      return typeof h == "object" && h !== null && h.$$typeof === r;
    }
    function Ze(h) {
      return I(h) === d;
    }
    function Xe(h) {
      return I(h) === a;
    }
    function he(h) {
      return I(h) === $;
    }
    function ve(h) {
      return I(h) === N;
    }
    function ae(h) {
      return I(h) === n;
    }
    function me(h) {
      return I(h) === i;
    }
    function oe(h) {
      return I(h) === o;
    }
    function Qe(h) {
      return I(h) === y;
    }
    O.AsyncMode = c, O.ConcurrentMode = L, O.ContextConsumer = P, O.ContextProvider = Je, O.Element = Ce, O.ForwardRef = Ke, O.Fragment = He, O.Lazy = Te, O.Memo = K, O.Portal = Q, O.Profiler = te, O.StrictMode = Oe, O.Suspense = $e, O.isAsyncMode = Pe, O.isConcurrentMode = pe, O.isContextConsumer = Ne, O.isContextProvider = Ae, O.isElement = ke, O.isForwardRef = Ze, O.isFragment = Xe, O.isLazy = he, O.isMemo = ve, O.isPortal = ae, O.isProfiler = me, O.isStrictMode = oe, O.isSuspense = Qe, O.isValidElementType = A, O.typeOf = I;
  }()), O;
}
process.env.NODE_ENV === "production" ? ur.exports = En() : ur.exports = _n();
var xn = ur.exports, et = xn, Sn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, wn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, rt = {};
rt[et.ForwardRef] = Sn;
rt[et.Memo] = wn;
var Rn = !0;
function Cn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var tt = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Rn === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, Tn = function(r, n, a) {
  tt(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function On(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var $n = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Vr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Pn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Nn = /[A-Z]|^ms/g, nt = /_EMO_([^_]+?)_([^]*?)_EMO_/g, mr = function(r) {
  return r.charCodeAt(1) === 45;
}, Lr = function(r) {
  return r != null && typeof r != "boolean";
}, or = /* @__PURE__ */ on(function(e) {
  return mr(e) ? e : e.replace(Nn, "-$&").toLowerCase();
}), We = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(nt, function(a, o, i) {
          return H = {
            name: o,
            styles: i,
            next: H
          }, o;
        });
  }
  return $n[r] !== 1 && !mr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var An = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, kn = ["normal", "none", "initial", "inherit", "unset"], In = We, Dn = /^-ms-/, Fn = /-(.)/g, Yr = {};
  We = function(r, n) {
    if (r === "content" && (typeof n != "string" || kn.indexOf(n) === -1 && !An.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = In(r, n);
    return a !== "" && !mr(r) && r.indexOf("-") !== -1 && Yr[r] === void 0 && (Yr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Dn, "ms-").replace(Fn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var at = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function we(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(at);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return H = {
          name: n.name,
          styles: n.styles,
          next: H
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            H = {
              name: a.name,
              styles: a.styles,
              next: H
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Mn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = H, l = n(e);
        return H = i, we(e, r, l);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var f = [], p = n.replace(nt, function(d, y, S) {
          var N = "animation" + f.length;
          return f.push("const " + N + " = keyframes`" + S.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + N + "}";
        });
        f.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(f, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var v = r[n];
  return v !== void 0 ? v : n;
}
function Mn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += we(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var l = n[i];
      if (typeof l != "object")
        r != null && r[l] !== void 0 ? a += i + "{" + r[l] + "}" : Lr(l) && (a += or(i) + ":" + We(i, l) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(at);
        if (Array.isArray(l) && typeof l[0] == "string" && (r == null || r[l[0]] === void 0))
          for (var f = 0; f < l.length; f++)
            Lr(l[f]) && (a += or(i) + ":" + We(i, l[f]) + ";");
        else {
          var p = we(e, r, l);
          switch (i) {
            case "animation":
            case "animationName": {
              a += or(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Pn), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var zr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, ot;
process.env.NODE_ENV !== "production" && (ot = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var H, Wr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  H = void 0;
  var l = r[0];
  l == null || l.raw === void 0 ? (o = !1, i += we(a, n, l)) : (process.env.NODE_ENV !== "production" && l[0] === void 0 && console.error(Vr), i += l[0]);
  for (var f = 1; f < r.length; f++)
    i += we(a, n, r[f]), o && (process.env.NODE_ENV !== "production" && l[f] === void 0 && console.error(Vr), i += l[f]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(ot, function(S) {
    return p = S, "";
  })), zr.lastIndex = 0;
  for (var v = "", d; (d = zr.exec(i)) !== null; )
    v += "-" + // $FlowFixMe we know it's not null
    d[1];
  var y = On(i) + v;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: p,
    next: H,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: H
  };
}, jn = function(r) {
  return r();
}, Vn = re["useInsertionEffect"] ? re["useInsertionEffect"] : !1, Ln = Vn || jn, Ge = {}.hasOwnProperty, yr = /* @__PURE__ */ re.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ bn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (yr.displayName = "EmotionCacheContext");
yr.Provider;
var Yn = function(r) {
  return /* @__PURE__ */ qr(function(n, a) {
    var o = Pt(yr);
    return r(n, o, a);
  });
}, it = /* @__PURE__ */ re.createContext({});
process.env.NODE_ENV !== "production" && (it.displayName = "EmotionThemeContext");
var Ur = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, zn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return Ur(n[1]);
}, Wn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Un = function(r) {
  return r.replace(/\$/g, "-");
}, Bn = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = zn(n[a]);
      if (o) {
        if (Wn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Un(o);
      }
    }
}, fr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", lr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", st = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    Ge.call(n, o) && (a[o] = n[o]);
  if (a[fr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = Bn(new Error().stack);
    i && (a[lr] = i);
  }
  return a;
}, qn = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return tt(n, a, o), Ln(function() {
    return Tn(n, a, o);
  }), null;
}, ct = /* @__PURE__ */ Yn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[fr], i = [a], l = "";
  typeof e.className == "string" ? l = Cn(r.registered, i, e.className) : e.className != null && (l = e.className + " ");
  var f = Wr(i, void 0, re.useContext(it));
  if (process.env.NODE_ENV !== "production" && f.name.indexOf("-") === -1) {
    var p = e[lr];
    p && (f = Wr([f, "label:" + p + ";"]));
  }
  l += r.key + "-" + f.name;
  var v = {};
  for (var d in e)
    Ge.call(e, d) && d !== "css" && d !== fr && (process.env.NODE_ENV === "production" || d !== lr) && (v[d] = e[d]);
  return v.ref = n, v.className = l, /* @__PURE__ */ re.createElement(re.Fragment, null, /* @__PURE__ */ re.createElement(qn, {
    cache: r,
    serialized: f,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ re.createElement(o, v));
});
process.env.NODE_ENV !== "production" && (ct.displayName = "EmotionCssPropInternal");
var ut = ct;
function Me(e, r, n) {
  return Ge.call(r, "css") ? Ye.jsx(ut, st(e, r), n) : Ye.jsx(e, r, n);
}
function Gn(e, r, n) {
  return Ge.call(r, "css") ? Ye.jsxs(ut, st(e, r), n) : Ye.jsxs(e, r, n);
}
const Jn = F`
  display: inline-flex;
  vertical-align: middle;
  white-space: nowrap;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  padding: 0 7px;
`, Kn = F`
  font-size: 14px;
  line-height: 22px;
  height: 32px;
`, Hn = F`
  font-size: 14px;
  line-height: 22px;
  height: 24px;
`, Zn = F`
  font-size: 12px;
  line-height: 18px;
  height: 18px;
`, Xn = F`
  font-size: inherit;
  line-height: inherit;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`, Qn = F`
  width: 12px;
  font-size: 12px;
  height: 12px;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  margin-right: 4px;
`;
F`
  font-size: 7px;
  margin-left: 4px;
  display: inline-flex;
  align-items: center;
  padding: 3px;
  border-radius: 50%;

  &:hover {
    background-color: ${U(`--${B}-grayBlue-07`)};
    cursor: pointer;
  }
`;
function ea(e, r, n) {
  let a, o = F();
  return r === "small" ? a = F({ padding: "2px" }) : a = F({ padding: "4px" }), n === "fill" ? o = F`
      &:hover {
        background-color: ${U(`--${B}-white-07`)};
      }
    ` : n === "outline" && (e === "gray" || e === "grayBlue") && (o = F`
        &:hover {
          background-color: ${U(`--${B}-${e}-08`)};
        }
      `), F`
    margin-left: 4px;
    display: inline-flex;
    align-items: center;
    padding: 3px;
    border-radius: 50%;

    &:hover {
      background-color: ${U(`--${B}-${e}-06`)};
      cursor: pointer;
    }

    ${a}
    ${o}
  `;
}
const ra = [
  "white",
  "blackAlpha",
  "gray",
  "grayBlue",
  "red",
  "orange",
  "yellow",
  "green",
  "blue",
  "cyan",
  "purple",
  "techPurple",
  "techPink"
];
function ta(e) {
  return e == "gray" || e == "grayBlue" ? F`
      border-radius: 4px;
      border: solid 1px ${U(`--${B}-${e}-08`)};
      color: ${U(`--${B}-${e}-02`)};
    ` : F`
      border-radius: 4px;
      border: solid 1px ${U(`--${B}-${e}-01`)};
      color: ${U(`--${B}-${e}-01`)};
    `;
}
function na(e) {
  return F`
    background-color: ${U(`--${B}-${e}-01`)};
    color: ${U(`--${B}-white-01`)};
    border-radius: 4px;
  `;
}
function aa(e) {
  return e == "grayBlue" ? F`
      border-radius: 4px;
      background-color: ${U(`--${B}-${e}-09`)};
      color: ${U(`--${B}-${e}-02`)};
    ` : F`
      border-radius: 4px;
      background-color: ${U(`--${B}-${e}-07`)};
      color: ${U(`--${B}-${e}-01`)};
    `;
}
function oa(e) {
  return F`
    border-radius: 4px;
    color: ${U(`--${B}-white-01`)};
    background-color: ${e};
  `;
}
function ia(e) {
  return F`
    border-radius: 4px;
    color: ${e};
    border: solid 1px ${e};
  `;
}
const sa = qr((e, r) => {
  const { visible: n, colorScheme: a = "gray", size: o = "medium", variant: i = "light", closable: l, ...f } = e, p = kt(f, ["onClose", "icon"]);
  let v;
  const [d, y] = Nt(!0);
  if (ra.includes(a))
    switch (i) {
      case "light": {
        v = aa(a);
        break;
      }
      case "fill": {
        v = na(a);
        break;
      }
      case "outline": {
        v = ta(a);
        break;
      }
    }
  else
    switch (i) {
      case "light":
      case "fill": {
        v = oa(a);
        break;
      }
      case "outline": {
        v = ia(a);
        break;
      }
    }
  let S;
  switch (o) {
    case "small": {
      S = Zn;
      break;
    }
    case "medium": {
      S = Hn;
      break;
    }
    case "large": {
      S = Kn;
      break;
    }
  }
  const N = F`
    ${Jn};
    ${v};
    ${S};
  `;
  return n ?? d ? Gn("div", { css: [N, It(e)], ref: r, ...Dt(p), children: [e.icon && Me("span", { css: Qn, children: e.icon }), Me("span", { css: Xn, children: e.children }), e.closable && Me("span", { css: ea(a, o, i), onClick: ($) => {
    e.onClose != null && e.onClose($), n == null && y(!1);
  }, children: Me(At, { size: "8px" }) })] }) : null;
});
sa.displayName = "Tag";
export {
  sa as Tag
};
//# sourceMappingURL=index.js.map
